// extracted by mini-css-extract-plugin
export default {"position-center":"ExportFundamentals_position-center__H1L0q"};